import { Api } from '@common/services/api';
import type { APIResponsePrivateMessage, PrivateMessage } from '../types/objects';

export type APIResponsePostMessage = {
  data: APIResponsePrivateMessage;
};

export const putMessage = async (organisationId: string, conversationId: string, messageId: string, values: PrivateMessage) => {
  const requests = [];
  if (values.text) {
    const message = { text: values.text };
    requests.push(message);
  }
  return Promise.all(requests.map(async (request) => {
    const response = await Api.put<APIResponsePostMessage>(
      `/v3/organisations/${organisationId}/conversations/${conversationId}/messages/${messageId}`, request,
    );
    return response.data;
  }));
};
